import React, { useState } from 'react';
import './Pricing.css';
import { iconwrapper } from '../../../../config/commonfunctions';
import { TICKWITHOUTCIRCLE_ICON } from '../../../../config/svgicons';
import { Checkdevice } from '../../../../components';

const pricingdata = {
    'lite': [
        'Up to 30 guests',
        'Grid Doodles Download',
        'Guestbook Download',
        'Email Support',
        'Support Photos Upload',
        'Support Text Upload',
        '1 Year Hosting'
    ],
    'premium': [
        'Up to 350 guests',
        'Grid Doodles Download',
        'Scatter Doodles Download',
        'Guestbook Download',
        'Email Support',
        'Customise Colors',
        'Customise Digital Guestbook Mode',
        'Support Photos Upload',
        'Support Text Upload',
        '1.5 Year Hosting'
    ]
}

{/* <div>Up to 350 guests</div>
<div>Customize colors</div>
<div>Customize display mode</div>
<div>Enable Scatter mode</div>
<div>Download all data</div> */}

function Pricing() {

    const device = Checkdevice()

    return (
        <div className='Gbfinaldisplay_root' style={{ display: 'flex', flexDirection: 'column' }}>
            <div className='Pricing_title'>Pricing</div>
            <div className='Gbdrawings_subtitle Gbfinaldisplay_root' style={{ display: 'flex', flexDirection: device === 'MOBILE' ? 'column' : 'row', placeContent: 'space-between', marginTop: 20 }}>


                <div
                    className='Guestbookedit_purchasepackage1'
                    style={{ border: '1px solid var(--subgrey)', height: 450, fontSize: 14, width: device === 'MOBILE' ? '100%' : 'calc( 100% - 5px )' }}
                >
                    <div
                        className='Guestbookedit_purchasetitle'
                        style={{ borderBottom: '1px solid var(--subgrey)', display: 'flex', flexDirection: 'column', height: 110 }}
                    >
                        <div>Lite</div>
                        <div style={{ fontSize: 24, padding: '10px 0px' }}>FREE</div>
                    </div>
                    <div style={{ padding: 10 }}>
                        {pricingdata['lite'].map((item, index) => {
                            return <div key={item + index} style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-start' }}>
                                {iconwrapper(TICKWITHOUTCIRCLE_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                                <div>{item}</div>
                            </div>
                        })}
                    </div>
                </div>

                {device !== 'MOBILE' ? <div style={{ width: 30 }} /> : null}

                <div
                    className='Guestbookedit_purchasepackage2'
                    style={{ border: '1px solid var(--subgrey)', height: 450, fontSize: 14, width: device === 'MOBILE' ? '100%' : 'calc( 100% - 5px )', marginTop: device === 'MOBILE' ? 10 : 0, }}
                >
                    <div
                        className='Guestbookedit_purchasetitle'
                        style={{ borderBottom: '1px solid var(--subgrey)', display: 'flex', flexDirection: 'column', height: 110 }}
                    >
                        <div>Premium</div>
                        <div
                            style={{ fontSize: 24, padding: '10px 0px 5px 0px', color: 'var(--mainpink)', cursor: 'pointer' }}
                            onClick={() => window.open('https://www.etsy.com/sg-en/shop/WeaveBlissStudio', '_blank')}
                        >
                            Visit Etsy Shop
                        </div>
                        <div style={{ paddingBottom: 10 }}>One-time payment</div>
                    </div>
                    <div style={{ padding: 10 }}>
                        {pricingdata['premium'].map((item, index) => {
                            return <div key={item + index} style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-start' }}>
                                {iconwrapper(TICKWITHOUTCIRCLE_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                                <div>{item}</div>
                            </div>
                        })}
                    </div>
                </div>


            </div>
        </div>
    );
}

export default Pricing;
